import { Component, OnInit, OnDestroy } from '@angular/core';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { SearchCifrasControlFilters } from "../../_models/cifras-control";
import { ZeroService } from '../../_services/zero/zero.service';
import { REST_SERVICES } from '../../_services/settings';
import { Globals } from '../../_services/zero/globals';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  selector: 'app-cifrascontrol',
  templateUrl: './cifrascontrol.component.html',
  styleUrls: ['./cifrascontrol.component.css'],
  host: ROUTE_ANIMATION_HOST,
  animations: [ROUTE_ANIMATION],
})
export class CifrascontrolComponent implements OnInit, OnDestroy {

  // Máscaras de fecha usadas en NOMBRE_ARCHIVO (bub_cat_archivos_batch), alineadas con
  // EGlobalMaskUtils.java del backend. Ordenadas de mayor a menor longitud de token
  // para evitar coincidencias parciales incorrectas.
  private static readonly MASCARAS_FECHA_ARCHIVO: Array<{ mascara: string, formato: string }> = [
    { mascara: 'AAAAMMDD', formato: 'yyyyMMdd' },
    { mascara: 'DDMMAAAA', formato: 'ddMMyyyy' },
    { mascara: 'AAAAMM', formato: 'yyyyMM' },
    { mascara: 'MMAAAA', formato: 'MMyyyy' },
    { mascara: 'AAMMDD', formato: 'yyMMdd' },
    { mascara: 'DDMM', formato: 'ddMM' },
    { mascara: 'MMDD', formato: 'MMdd' }
  ];

  public filtersForSearches: any; 
  public options: Pickadate.DateOptions;
  
  public archivoCifrasList: Array<any>; 

  public seriesEstatusEjecuciones: Array<any> = [];
  public legendEstatusEjecuciones: Array<any> = [];
  public totalEjecucionesPeriodo: number = 0;
  public chartVisibleEstatusEjecuciones: boolean = false;
  public readonly schemeEstatusEjecuciones = { domain: ['#26a69a', '#ffb300', '#f44336'] };

  private datePipe: DatePipe;
  
  private pollingTimer: any;

  constructor(
    private zeroService: ZeroService,
    private globals: Globals,
    private toast: ToastrService) {
    
    this.options = globals.optionsByPickerdate;
    this.filtersForSearches = new SearchCifrasControlFilters();
    this.datePipe = new DatePipe('es-MX');
  }

  ngOnInit() {
    this.filtersForSearches.idTipoArchivo = null; 
    this.filtersForSearches.periodo = 0;

    this.updateFechas();
    
    this.archivoCifrasList = new Array<any>();
    this.actualizarGraficaEstatus([]);
  }

  ngOnDestroy() {
    this.detenerPolling();
  }

  private formatLocalDate(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  updateFechas() {
    let periodoDias = Number(this.filtersForSearches.periodo);

    if (periodoDias === -1) {
      this.filtersForSearches.fechaCorte = null;
      this.filtersForSearches.fechaInicio = null;
      this.filtersForSearches.fechaFin = null;
      return;
    }

    if (periodoDias === 0) {
      this.filtersForSearches.fechaCorte = this.formatLocalDate(new Date());
    }

    if (!this.filtersForSearches.fechaCorte) return;
    
    const [year, month, day] = this.filtersForSearches.fechaCorte.split('-');
    let fechaInicio = new Date(Number(year), Number(month) - 1, Number(day));
    let fechaFin = new Date(Number(year), Number(month) - 1, Number(day));
    
    if(periodoDias > 0) {
        fechaInicio.setDate(fechaInicio.getDate() - periodoDias);
    }
    
    this.filtersForSearches.fechaInicio = this.formatLocalDate(fechaInicio);
    this.filtersForSearches.fechaFin = this.formatLocalDate(fechaFin);
  }

  // Normaliza a número los totales que el backend puede enviar como null,
  // undefined o cadena, para poder sumarlos y formatearlos en la vista.
  private aNumero(valor: any): number {
    if (valor === null || valor === undefined || valor === '') {
      return 0;
    }
    const numero = Number(valor);
    return isNaN(numero) ? 0 : numero;
  }

  private configurarElemento(element: any) {
    const valorEstatus = element.estatus || element.idEstatusFk || element.id_estatus_fk;
    const estatusId = (valorEstatus !== null && valorEstatus !== undefined) ? Number(valorEstatus) : 1;
    const fechaRealBD = element.fechaOperacion || element.fchOperacion;
    
    element.estatusNumerico = estatusId;

    // El backend puede regresar los totales como string o null; se normalizan a
    // número para poder sumarlos y formatearlos en la bitácora de ejecuciones.
    element.total = this.aNumero(element.total);
    element.totalExitosos = this.aNumero(element.totalExitosos);
    element.totalFallidos = this.aNumero(element.totalFallidos);

    if (fechaRealBD) {
      const fchOp = new Date(fechaRealBD);
      element.fechaOperacionFormat = this.datePipe.transform(fchOp, 'dd/MM/yyyy') || '';
      element.horaEjecucion = this.datePipe.transform(fchOp, 'HH:mm:ss') || '';
      element.timestamp = fchOp.getTime();
    } else {
      element.fechaOperacionFormat = 'Sin fecha';
      element.horaEjecucion = '--:--:--';
      element.timestamp = 0;
    }

    element.nombreArchivoDisplay = this.resolverNombreArchivo(element.nombreArchivo, element.timestamp);

    switch (estatusId) {
      case 1:
        element.colorSemaforo = "green"; 
        element.textoEstatus = "EXITOSO"; 
        element.mensajeToolSemaforo = `Exitoso a las ${element.horaEjecucion}`; 
        break;
      case 2:
        element.colorSemaforo = "amber"; 
        element.textoEstatus = "EN PROCESO"; 
        element.mensajeToolSemaforo = `En Proceso desde las ${element.horaEjecucion}`; 
        break;
      case 3:
      default:
        element.colorSemaforo = "red"; 
        element.textoEstatus = "ERROR"; 
        element.mensajeToolSemaforo = `Error a las ${element.horaEjecucion}`; 
        break;
    }
  }

  // Reemplaza la máscara de fecha estática dentro del nombre de archivo (ej. AAMMDD)
  // por la fecha real de la ejecución correspondiente. Si no se reconoce ninguna
  // máscara, o no hay fecha de ejecución válida, se regresa el nombre sin cambios.
  private resolverNombreArchivo(nombreArchivo: string, timestamp: number): string {
    if (!nombreArchivo || !timestamp) {
      return nombreArchivo;
    }

    const mascaraEncontrada = CifrascontrolComponent.MASCARAS_FECHA_ARCHIVO.find(
      m => nombreArchivo.includes(m.mascara)
    );

    if (!mascaraEncontrada) {
      return nombreArchivo;
    }

    const fechaFormateada = this.datePipe.transform(new Date(timestamp), mascaraEncontrada.formato);
    return fechaFormateada ? nombreArchivo.replace(mascaraEncontrada.mascara, fechaFormateada) : nombreArchivo;
  }

  // Calcula el desglose de estatus (Exitoso/Pendiente/Error) de las ejecuciones
  // del periodo consultado, para alimentar la gráfica de pastel.
  private actualizarGraficaEstatus(elementos: Array<any>) {
    const conteo = { exitoso: 0, pendiente: 0, error: 0 };

    elementos.forEach((element: any) => {
      if (element.estatusNumerico === 1) {
        conteo.exitoso++;
      } else if (element.estatusNumerico === 2) {
        conteo.pendiente++;
      } else {
        conteo.error++;
      }
    });

    const total = elementos.length;
    this.totalEjecucionesPeriodo = total;

    this.seriesEstatusEjecuciones = [
      { name: 'Exitoso', value: conteo.exitoso },
      { name: 'Pendiente', value: conteo.pendiente },
      { name: 'Error', value: conteo.error }
    ];

    this.legendEstatusEjecuciones = [
      { label: 'Exitoso', value: conteo.exitoso, colorClass: 'bg-green', pct: this.calcularPorcentaje(conteo.exitoso, total) },
      { label: 'Pendiente', value: conteo.pendiente, colorClass: 'bg-amber', pct: this.calcularPorcentaje(conteo.pendiente, total) },
      { label: 'Error', value: conteo.error, colorClass: 'bg-red', pct: this.calcularPorcentaje(conteo.error, total) }
    ];

    this.chartVisibleEstatusEjecuciones = total > 0;
  }

  private calcularPorcentaje(valor: number, total: number): number {
    return total ? Math.round((valor / total) * 1000) / 10 : 0;
  }
  
  buscarCifrasControl(isSilent: boolean = false) {
    const f = this.filtersForSearches;

	    if (!f.idTipoArchivo) {
	      if (!isSilent) {
	        this.toast.warning('Por favor seleccione el Tipo de Búsqueda (Cargas o Extractos)', 'Aviso', { positionClass: 'toast-center-center' });
	      }
	      return;
	    }
    
    const fechaInicioFmt = f.fechaInicio ? this.datePipe.transform(f.fechaInicio, 'yyyy/MM/dd') : '';
    const fechaFinFmt = f.fechaFin ? this.datePipe.transform(f.fechaFin, 'yyyy/MM/dd') : '';
    
    let url = `${REST_SERVICES.BUSQUEDA_CIFRAS_CONTROL}${f.idTipoArchivo}`;
    if (fechaInicioFmt && fechaFinFmt) url += `&fechaInicio=${fechaInicioFmt}&fechaFin=${fechaFinFmt}`;

    this.zeroService.request({
      isSingleResponse: false,
      uri: url,
      method: "GET",
      showInfo: !isSilent,   
      showLoading: !isSilent, 
      ok: (response) => {
        if (response.responsecode == "0" && response.response) {
          
          const mapAgrupado = new Map<string, any>();

          response.response.forEach((element: any) => {

            this.configurarElemento(element);

            if (!mapAgrupado.has(element.idExtracto)) {
              mapAgrupado.set(element.idExtracto, {
                idExtracto: element.idExtracto,
                origen: element.origen,
                destino: element.destino,
                totalEjecuciones: 1,
                totalRegistrosAcumulado: element.total,
                historial: [element],
                latest: element,    
                mostrarHistorial: false
              });
            } else {
              const grupo = mapAgrupado.get(element.idExtracto);
              grupo.totalEjecuciones++;
              grupo.totalRegistrosAcumulado += element.total;
              grupo.historial.push(element);

              const timestampActual = grupo.latest.timestamp;
              const timestampNuevo = element.timestamp;

              if (timestampNuevo > timestampActual) {
                  grupo.latest = element;
              } 
              else if (timestampNuevo === timestampActual) {
                  if (element.estatusNumerico === 2 || grupo.latest.estatusNumerico !== 2) {
                      grupo.latest = element;
                  }
              }
            }
          });

          this.archivoCifrasList = Array.from(mapAgrupado.values());
          
          this.archivoCifrasList.sort((a, b) => a.idExtracto.localeCompare(b.idExtracto));

          this.archivoCifrasList.forEach(grupo => {
             grupo.historial.sort((a, b) => b.timestamp - a.timestamp);
          });

          this.actualizarGraficaEstatus(response.response);

          const hayProcesosActivos = this.archivoCifrasList.some(grupo => grupo.latest.estatusNumerico === 2);
          
          if (hayProcesosActivos) {
             this.iniciarPolling();
          } else {
             this.detenerPolling(); 
          }

        } else {
          this.archivoCifrasList = [];
          this.actualizarGraficaEstatus([]);
          if (!isSilent) {
              this.toast.warning('No se encontraron registros en el periodo seleccionado', 'Sin Datos', { positionClass: 'toast-center-center' });
          }
        }
      }
    });
  }

  private iniciarPolling() {
    this.detenerPolling(); 
    this.pollingTimer = setTimeout(() => {
      this.buscarCifrasControl(true); 
    }, 30000); // 30000 ms = 30 segundos
  }

  private detenerPolling() {
    if (this.pollingTimer) {
      clearTimeout(this.pollingTimer);
      this.pollingTimer = null;
    }
  }

  toggleHistorial(grupo: any) {
    grupo.mostrarHistorial = !grupo.mostrarHistorial;
  }

  limpiar() {
    this.detenerPolling();
    this.filtersForSearches = new SearchCifrasControlFilters();
    this.filtersForSearches.idTipoArchivo = null;
    this.filtersForSearches.periodo = 0; 
    this.updateFechas();
    this.archivoCifrasList = [];
    this.actualizarGraficaEstatus([]);
  }
}